import type { AxiosInstance } from 'axios'
import type { IAssignedSubAccountData, IAssignedSubAccountSimple } from '@/typings/subAccount'
import { NO_CONTENT_CODE } from '@/config/httpCodes.ts'
import type { IAttachmentToDownload } from '@/typings/api'

export default (axios: AxiosInstance) => ({
    getAssignedSubAccounts: async (): Promise<IAssignedSubAccountSimple[]> => {
        const { data } = await axios.get<IAssignedSubAccountSimple[]>(
            '/guardian/subaccount/assigned-subaccounts',
        )

        return data
    },

    getSubAccountDataById: async (subAccountId: string): Promise<IAssignedSubAccountData> => {
        const { data } = await axios.get<IAssignedSubAccountData>(
            `/guardian/${subAccountId}/subaccount/details`,
        )

        return data
    },

    acceptRodoForSubAccountId: async (subAccountId: string): Promise<boolean> => {
        const { status } = await axios.patch(`/guardian/${subAccountId}/subaccount/accept-rodo`)

        return status === NO_CONTENT_CODE
    },

    getWardCertificate: async (subAccountId: string): Promise<IAttachmentToDownload> => {
        const { data } = await axios.get<IAttachmentToDownload>(
            `/guardian/${subAccountId}/subaccount/ward-certificate`,
            {
                params: {
                    base64: true,
                },
            },
        )

        return data
    },
})
